import { PrintTemplate } from "./printTemplates";

interface PrintConfig {
  isDelivery: boolean;
  isTableSession: boolean;
  hasWithdrawal: boolean;
}

function getPrintConfig(data: CommonData): PrintConfig {
  return {
    isDelivery: !!(
      ("is_delivery" in data && data.is_delivery) ||
      (data.print_object &&
        "is_delivery" in data.print_object &&
        data.print_object.is_delivery)
    ),
    isTableSession: data.print_type === "table_session",
    hasWithdrawal:
      "with_withdrawal" in data.print_object
        ? !!data.print_object.with_withdrawal
        : false,
  };
}

export function newPrintFunction(data: CommonData): string {
  const config = getPrintConfig(data);

  const header = config.isDelivery
    ? PrintTemplate.buildDeliveryHeader(data)
    : PrintTemplate.buildTableSessionHeader(data);

  const orderItems = config.isDelivery
    ? PrintTemplate.buildAllOrdersDelivery(data)
    : PrintTemplate.buildAllOrders(data);
  const totals = !config.isDelivery
    ? PrintTemplate.buildTotals(data)
    : PrintTemplate.buildTotals(data);
  const payments = !config.isDelivery
    ? PrintTemplate.buildPayments(data)
    : PrintTemplate.buildPaymentsDelivery(data);

  const headerHtml = PrintTemplate.renderElement(header);
  const bodyHtml = `
    ${PrintTemplate.renderElement(orderItems)}
    ${PrintTemplate.renderElement(totals)}
    ${PrintTemplate.renderElement(payments)}
  `;

  return `
          <div id="header">${headerHtml}</div>
          <div id="body">${bodyHtml}</div>
  `;
}
